<footer class="footer">
  <div class="footer__container">
    <div class="footer__top">
      <div class="footer__brand">
        <button mat-button class="footer__brand-btn" (click)="scrollToTop()" aria-label="Vissza az oldal tetejére">
          @if (profile(); as p) {
            <span class="footer__brand-name">
              {{ p.brandName }}<span class="footer__brand-accent">{{ p.brandAccent }}</span>
            </span>
          }
        </button>
        <p class="footer__tagline">
          Weboldal, ami nem csak úgy "van" –<br>hanem <strong>dolgozik is a vállalkozásodért.</strong>
        </p>
      </div>

      <nav class="footer__nav" aria-label="Lábléc navigáció">
        <p class="footer__nav-heading">Navigáció</p>
        <ul class="footer__nav-list">
          @for (item of navItems(); track item.fragment) {
            <li>
              <button mat-button class="footer__link" (click)="scrollTo(item.fragment)">
                {{ item.label }}
              </button>
            </li>
          }
        </ul>
      </nav>

      <div class="footer__contact">
        <p class="footer__nav-heading">Kapcsolat</p>
        <ul class="footer__contact-list">
          @if (contactInfo(); as info) {
            <li>
              <mat-icon>mail</mat-icon>
              <a [href]="'mailto:' + info.email" class="footer__contact-link">{{ info.email }}</a>
            </li>
            <li>
              <mat-icon>phone</mat-icon>
              <a [href]="info.phoneHref" class="footer__contact-link">{{ info.phone }}</a>
            </li>
          }
        </ul>
        <button
          mat-raised-button
          class="btn-primary footer__cta"
          (click)="scrollTo('kapcsolat')"
        >
          {{ profile()?.navbarCtaLabel }}
        </button>
      </div>
    </div>

    <div class="footer__bottom">
      <div class="footer__bottom-left">
        <p class="footer__copy">&copy; {{ currentYear }} {{ profile()?.name }}. Minden jog fenntartva.</p>
        <nav class="footer__legal" aria-label="Jogi információk">
          <a routerLink="/adatvedelmi-nyilatkozat" class="footer__legal-link">Adatvédelmi nyilatkozat</a>
          <span class="footer__legal-sep" aria-hidden="true">·</span>
          <a routerLink="/impressum" class="footer__legal-link">Impresszum</a>
        </nav>
      </div>
      <button mat-icon-button class="footer__scroll-top" aria-label="Vissza az oldal tetejére" (click)="scrollToTop()">
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>
    </div>
  </div>
</footer>
